import { render, staticRenderFns } from "./ActionPlanPresentation.vue?vue&type=template&id=36b7f613&scoped=true&"
import script from "./ActionPlanPresentation.vue?vue&type=script&lang=js&"
export * from "./ActionPlanPresentation.vue?vue&type=script&lang=js&"
import style0 from "./ActionPlanPresentation.vue?vue&type=style&index=0&id=36b7f613&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b7f613",
  null
  
)

export default component.exports